import {type RootState} from 'stores/redux_store';

export const hasFormattingBar = (state: RootState): boolean =>
    state.editorSettings.hasFormattingBar;
